export const isVisible = (
    parent?: HTMLElement | null,
    child?: HTMLElement | null
): boolean => {

    if (!parent || !child) {
        return false;
    }

    return !(
        child.offsetLeft - parent.offsetLeft > parent.offsetWidth ||
        child.offsetTop - parent.offsetTop > parent.offsetHeight
    );

};

export const setTabIndex = (node: HTMLElement, index: number): void => {
    if (node) {
        node.tabIndex = index;
    }
};